import { PipeTransform, Pipe } from '@angular/core';
import { enumToImageList } from '../enum-to-list';
import { IdNameImage } from '../../models/id-name-image.model';
import { IncidentNature } from '../../enums/incident-nature.enum';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import * as _ from 'lodash';

@Pipe({
  name: 'incidentNature',
  standalone: false
})
export class IncidentNaturePipe implements PipeTransform {
  public transform(value: IncidentNature): string {
    return getIncidentNature(value);
  }
}

export function getIncidentNature(value: IncidentNature): string {
  switch (value) {
    case IncidentNature.Corrective:
      return 'Corrective';
    case IncidentNature.Positive:
      return 'Positive';
    case IncidentNature.Neutral:
      return 'Neutral';
    default:
      throw new Error(`Unsupported value for IncidentNature: ${value}.`);
  }
}

export function getIncidentNatureImage(value: IncidentNature, domSanitizer: DomSanitizer): SafeResourceUrl {
  let result;

  switch (value) {
    case IncidentNature.Corrective:
      result =
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiNGNzAwMEYiLz48cmVjdCB4PSI0IiB5PSI3IiB3aWR0aD0iOCIgaGVpZ2h0PSIyIiBmaWxsPSIjRkZGRkZGIi8+PC9zdmc+';
      break;
    case IncidentNature.Positive:
      result =
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiMwOUFGMDAiLz48cmVjdCB4PSI0IiB5PSI3IiB3aWR0aD0iOCIgaGVpZ2h0PSIyIiBmaWxsPSIjRkZGRkZGIi8+PHJlY3QgeD0iNyIgeT0iNCIgd2lkdGg9IjIiIGhlaWdodD0iOCIgZmlsbD0iI0ZGRkZGRiIvPjwvc3ZnPg==';
      break;
    case IncidentNature.Neutral:
      result =
        'data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiI+PGNpcmNsZSBjeD0iOCIgY3k9IjgiIHI9IjgiIGZpbGw9IiNEMEQwRDAiLz48L3N2Zz4=';
      break;
    default:
      throw new Error(`Unsupported value for IncidentNature: ${value}.`);
  }

  return domSanitizer.bypassSecurityTrustResourceUrl(result);
}

const INCIDENT_NATURES_ORDER = [IncidentNature.Positive, IncidentNature.Neutral, IncidentNature.Corrective];

export function getIncidentNatureList(domSanitizer: DomSanitizer): IdNameImage[] {
  return _.chain(enumToImageList(IncidentNature, getIncidentNature, (x) => getIncidentNatureImage(x, domSanitizer)))
    .orderBy((x) => INCIDENT_NATURES_ORDER.indexOf(x.id))
    .value();
}
